export const LANGUAGE_PREFERENCE_KEY = 'anidex-lang';

export type AppLanguage = 'fr' | 'en';


const FRENCH_COUNTRIES = new Set([
  'FR',
  'BE',
  'CH',
  'LU',
  'MC',
  'CA',
  'SN',
  'CI',
  'CM',
  'ML',
  'BF',
  'NE',
  'TG',
  'BJ',
  'GA',
  'CG',
  'CD',
  'MG',
  'DJ',
  'KM',
  'RW',
  'BI',
  'TD',
  'CF',
  'GN',
  'GQ',
  'SC',
  'MU',
  'HT',
  'VU',
  'NC',
  'PF',
  'WF',
  'PM',
  'RE',
  'GP',
  'MQ',
  'GF',
  'YT',
  'BL',
  'MF',
]);

export function explicitLanguage(value: string | null | undefined): AppLanguage | null {
  const token = value?.trim().toLowerCase();
  if (token === 'fr' || token === 'en') return token;
  return null;
}

export function languageFromCookieHeader(header: string | null | undefined): AppLanguage | null {
  if (!header) return null;
  for (const part of header.split(';')) {
    const piece = part.trim();
    if (!piece.startsWith(`${LANGUAGE_PREFERENCE_KEY}=`)) continue;
    try {
      return explicitLanguage(decodeURIComponent(piece.slice(LANGUAGE_PREFERENCE_KEY.length + 1)));
    } catch {
      return null;
    }
  }
  return null;
}


export function languageFromCountry(country: string | null | undefined): AppLanguage | null {
  if (!country) return null;
  const code = country.trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(code) || code === 'XX' || code === 'T1') return null;
  return FRENCH_COUNTRIES.has(code) ? 'fr' : 'en';
}


export function languageFromAcceptLanguage(header: string | null | undefined): AppLanguage | null {
  if (!header) return null;
  for (const part of header.split(',')) {
    const tag = part.split(';')[0]?.trim().toLowerCase() ?? '';
    if (tag.startsWith('fr')) return 'fr';
    if (tag.startsWith('en')) return 'en';
  }
  return null;
}


export function resolveVisitorLanguage(input: {
  explicit?: string | null;
  country?: string | null;
  acceptLanguage?: string | null;
}): AppLanguage {
  return (
    explicitLanguage(input.explicit) ??
    languageFromCountry(input.country) ??
    languageFromAcceptLanguage(input.acceptLanguage) ??
    'fr'
  );
}

export function htmlLanguage(language: AppLanguage): 'fr' | 'en' {
  return language;
}

export function ogLocale(language: AppLanguage): 'fr_FR' | 'en_US' {
  return language === 'en' ? 'en_US' : 'fr_FR';
}

export function intlLocale(language: AppLanguage): 'fr-FR' | 'en-US' {
  return language === 'en' ? 'en-US' : 'fr-FR';
}
